module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper main-container"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "search-area"
  }, [_c('form', {
    staticClass: "mb-xl top-margin form-row",
    attrs: {
      "role": "form",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback searchbox"
  }, [_c('div', {
    staticClass: "dropdown",
    class: _vm.isSearchOpen ? 'dropdown-open' : 'dropdown-closed',
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggleIsSearchOpen,
      "blur": function($event) {
        _vm.isSearchOpen = false
      }
    }
  }, [(!_vm.isSearchOpen) ? _c('h4', {
    staticClass: "current-search-by"
  }, [_vm._v(_vm._s(_vm.currentSearchByDisplay)), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('h4', {
    staticClass: "current-search-by",
    attrs: {
      "id": "filter-by"
    }
  }, [_vm._v("Filter by")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content"
  }, _vm._l((_vm.searchTypes), function(searchType) {
    return _c('li', {
      key: searchType.name,
      staticClass: "search-option",
      on: {
        "click": function($event) {
          _vm.updatedSearchingBy(searchType)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      class: _vm.currentSearchByDisplay !== searchType.displayName ? 'transparent-text' : '',
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                    " + _vm._s(searchType.displayName) + "\n                  ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "search-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "id": "search",
      "type": "text",
      "placeholder": "Enter your search here...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "focus": _vm.onSearchFocus,
      "blur": _vm.onSearchBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasSearched || _vm.search) ? _c('p', {
    attrs: {
      "id": "clear-icon"
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitSearch
    },
    on: {
      "click": _vm.searchInvestors
    }
  }, [_c('em', {
    staticClass: "icon-magnifier pr-sm"
  }), _vm._v(" Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.goToCreateUser()
      }
    }
  }, [_c('em', {
    staticClass: "icon-user-follow pr-sm"
  }), _vm._v(" Create new user")])])]), _vm._v(" "), _c('recent-records', {
    attrs: {
      "visible": _vm.isSearchFocused
    }
  })], 1), _vm._v(" "), (_vm.isSearchLoading) ? _c('spinner', {
    staticClass: "table-spinner"
  }) : _c('div', {
    staticClass: "panel-heading"
  }, [(_vm.areResultsEmpty && !_vm.isSearchLoading) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('section', {
    staticClass: "search-message--no-result"
  }, [_c('i', {
    staticClass: "fa fa-window-close-o"
  }), _vm._v(" "), _c('h4', [_vm._v("No results found for \"" + _vm._s(_vm.searchMessage) + "\"")]), _vm._v(" "), _c('p', [_vm._v("Make sure your text is spelled correctly or try with a different keyword.")])])])]) : (!_vm.hasSearched && !_vm.isSearchLoading) ? _c('div', [_c('section', {
    staticClass: "search-message--empty"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('h4', [_vm._v("You can search by:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Name / email - using investor's name, account name or email")]), _vm._v(" "), _c('li', [_vm._v("Advisor firm - using company name 1 or company name 2")]), _vm._v(" "), _c('li', [_vm._v("Note number or CUSIP")]), _vm._v(" "), _c('li', [_vm._v("Account number")])])])]) : _c('div', [(_vm.results) ? _c('div', {
    staticClass: "table-responsive top-margin"
  }, [(_vm.searchingBy === 'ACCOUNT_NUMBER') ? _c('search-by-account-results', {
    attrs: {
      "results": _vm.results,
      "searchMessage": _vm.searchMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchingBy === 'NAME_EMAIL' || _vm.searchingBy === 'ADVISOR_FIRM') ? _c('search-by-name-or-email-results', {
    attrs: {
      "results": _vm.results,
      "searchMessage": _vm.searchMessage,
      "show-company-names": _vm.searchingBy === 'ADVISOR_FIRM'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchingBy === 'NOTE_NUMBER' || _vm.searchingBy === 'CUSIP') ? _c('search-by-note-number-or-cusip-results', {
    attrs: {
      "results": _vm.results,
      "searchMessage": _vm.searchMessage
    }
  }) : _vm._e()], 1) : _vm._e()])])], 1)])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c21f096","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users.vue
// module id = 2183
// module chunks = 1